<app-modal *ngIf="vo$ | async; let vo" class="consumer-mapping-popup">
	<div modal-body class="consumer-mapping-popup__body">
		<div class="consumer-mapping-popup__info">
			<dc-alert
				[type]="'info'"
				message="message"
				i18n-message="@@exposition.access.consumer.mapping.popup.details"></dc-alert>
		</div>

		<div
			class="consumer-mapping-popup__selected-consumers"
			[class.no-selection]="vo.selectedConsumers.length === 0">
			<div
				*ngIf="vo.selectedConsumers.length !== 0"
				class="consumer-selection-chips">
				<app-chip
					*ngFor="let item of vo.selectedConsumers"
					viewMode="default"
					(remove)="removeSelectedConsumer(item.id)">
					<mat-icon
						*ngIf="item.isGroup"
						[svgIcon]="DcIcons.Group"
						app-chip-icon></mat-icon>
					<app-avatar
						*ngIf="!item.isGroup && item.avatar"
						[avatar]="item.avatar"
						app-chip-icon></app-avatar>
					<span>{{ item.name }}</span>
				</app-chip>
			</div>
			<div
				*ngIf="vo.selectedConsumers.length === 0"
				class="consumer-selection-area">
				<span i18n="@@exposition.access.consumer.mapping.popup.no-selection">
					no-selection
				</span>
			</div>
		</div>

		<div class="consumer-mapping-popup__consumers">
			<app-toggle-buttons [actions]="consumerTypes"></app-toggle-buttons>
			<app-panel
				headerHeight="3.25rem"
				isAlwaysOpen="true"
				hasSearchableGrid="true"
				hasRefresh="true"
				maxActionsCount="6"
				[itemsCount]="vo.consumerList.totalItemsCount"
				(refresh)="refresh()"
				(search)="search($event)">
				<div
					*ngIf="consumerType$ | async; let consumerType"
					panel-title
					class="app-panel__title">
					<ng-container *ngIf="consumerType === ConsumerType.User">
						<mat-icon [svgIcon]="DcIcons.User"></mat-icon>
						<span i18n="@@general.memberType.users">users</span>
					</ng-container>

					<ng-container *ngIf="consumerType === ConsumerType.Group">
						<mat-icon [svgIcon]="DcIcons.Group"></mat-icon>
						<span i18n="@@general.memberType.groups">groups</span>
					</ng-container>
				</div>
				<app-member-list
					[memberList]="vo.consumerList"
					[initialSelectedMembers]="vo.initialSelectedConsumers"
					(optionChanged)="onOptionChange($event)"
					(selectItems)="selectTargetConsumers($event)"></app-member-list>
			</app-panel>
		</div>
	</div>
	<div modal-footer class="consumer-mapping-popup__footer">
		<button
			id="{{ cmpId }}-save-btn"
			class="consumer-mapping-popup__footer__btn"
			[color]="'primary'"
			[disabled]="vo.selectedConsumers.length === 0"
			(click)="saveAction()"
			mat-raised-button>
			<span i18n="@@general.action.save">save</span>
		</button>
	</div>
</app-modal>
